import { useContext, useEffect, useRef, useState, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment-timezone';

import { SocketContext } from '../../context/SocketContext';

import { CustomCalendar } from './components/CustomCalendar';
import { Filters } from './components/Filters';
import { ModalDeleteCita } from './components/ModalDeleteCita';
import { ModalReserva } from './components/ModalReserva';
import { setBodyClass, setMenuLateral } from '../../actions/ui';
import { startLoadingCitasMes, startLoadingCitasMesForced, setCitas, unactiveCita } from '../../actions/citas';
import { YlmModalTwoButtons } from '../../components/main/YlmModalTwoButtons';
import { pedidoLogout } from '../../actions/pedidos';
import { ModalVentas } from './components/ModalVentas';
import { startLoadingPedidosPendientes } from '../../actions/pedidos';
import { startLoadingVacacionesEmpresa } from '../../actions/vacaciones';
import { unactiveServicio } from '../../actions/servicios';

const usarSockets = process.env.REACT_SOCKETS;
//const timezone = process.env.REACT_APP_TIMEZONE;

export const Reservas = ({ history }) => {

    const dispatch = useDispatch();
    const { colores } = useSelector(state => state.ui);
    const { empresa, profesional } = useSelector(state => state.auth);
    const { sucursales } = useSelector(state => state.sucursales);
    const { profesionales } = useSelector(state => state.profesionales);
    const citasState = useSelector(state => state.citas);
    const { citas, active: citaActive } = citasState;

    const [firstTime, setFirstTime] = useState(false);
    const [arrSucursales, setArrSucursales] = useState([]);
    const [arrProfesionales, setArrProfesionales] = useState([]);
    const [selectedDate, setSelectedDate] = useState(moment());
    const fechaString = useMemo(() => selectedDate.toISOString(), [selectedDate]);
    
    const [viewValue, setViewValue] = useState('month');
    const [miniLateral, setMiniLateral] = useState(true);
    const [miniFilters, setMiniFilters] = useState(true);
    const [activeModalReserva, setActiveModalReserva] = useState(false);
    const [activeModalDeleteCita, setActiveModalDeleteCita] = useState(false);
    const [agendaActive, setAgendaActive] = useState(true);
    const [estadoCita, setEstadoCita] = useState("");

    const [editCita, setEditCita] = useState(false);
    const { socket } = useContext(SocketContext);

    const [isLoading, setIsLoading] = useState(false);
    const [isRecharging, setIsRecharging] = useState(false);

    const myTimer = useRef(null);

    const [dataModal, setDataModal] = useState({
        title: '¿Modificar cita?',
        text: ['¿Estás seguro de modificar esta cita?'],
        buttonText: 'Estoy seguro',
        button2Text: 'Cancelar'
    });
    const [modalTwoButtonsOpened, setModalTwoButtonsOpened] = useState(false);
    const [modalResponse, setModalResponse] = useState(0);
    const [modalWaiting, setModalWaiting] = useState({});
    const [activeModalVentas, setActiveModalVentas] = useState(false);
    const [ventaModoCitaCompleta, setVentaModoCitaCompleta] = useState(false);
    const [hasAppliedNavigationState, setHasAppliedNavigationState] = useState(false);
    const [targetCitaId, setTargetCitaId] = useState(null);
    const [isRestoringNavigationState, setIsRestoringNavigationState] = useState(false);
    const [previousSelectedDate, setPreviousSelectedDate] = useState(null);
    const navState = history?.location?.state;
    const hasNavState = !!(navState?.selectedDate || navState?.viewValue || navState?.calendarState);
    const skipNextSelectedDateLoad = useRef(hasNavState);
    const justRestoredAt = useRef(0);
    
    useEffect(() => {
        if (skipNextSelectedDateLoad.current) {
            skipNextSelectedDateLoad.current = false;
            return;
        }

        if (empresa && fechaString && !isRestoringNavigationState) {
            dispatch(startLoadingCitasMesForced(empresa, fechaString, profesional?._id));
        }
    }, [empresa, fechaString, profesional?._id, dispatch, isRestoringNavigationState]);
    
    useEffect(() => {
        const st = history?.location?.state || {};
        const nav = st.calendarState ? st.calendarState : st;

        if (!hasAppliedNavigationState && (nav.selectedDate || nav.viewValue || nav.citaId)) {
            const fechaFromState = nav.selectedDate ? moment(nav.selectedDate) : moment();

            if (nav.selectedDate) setSelectedDate(fechaFromState);
            if (nav.viewValue) setViewValue(nav.viewValue);
            if (nav.citaId) {
                setTargetCitaId(nav.citaId);
            } else if (nav.viewValue === 'day' && history.location.state) {
                setTargetCitaId('first');
            }
            if (nav.previousSelectedDate) setPreviousSelectedDate(moment(nav.previousSelectedDate));
            
            setIsRestoringNavigationState(true);
            
            if (empresa) {
                const fechaString = fechaFromState.toISOString();
                const monthKey = fechaString.substring(0, 7); // "YYYY-MM"
                
                
                if (citasState.citasByMonth && citasState.citasByMonth[monthKey]) {
                    dispatch(setCitas({ 
                        citas: citasState.citasByMonth[monthKey], 
                        fecha: fechaString 
                    }));
                } else {
                    if (usarSockets && socket) {
                        socket.emit('obtener-citas-mes', {
                            empresa,
                            fecha: fechaString,
                            profesionalId: profesional?._id || undefined,
                        });
                    } else {
                        dispatch(startLoadingPedidosPendientes(empresa));
                        dispatch(startLoadingCitasMes(empresa, fechaString, profesional?._id || undefined));
                    }
                }
            }

            skipNextSelectedDateLoad.current = true;
            justRestoredAt.current = Date.now();
            setIsRestoringNavigationState(false);
            setHasAppliedNavigationState(true);
        } else if (!history.location.state && !hasAppliedNavigationState) {
            const monthKey = moment().format('YYYY-MM');
            if (citasState.citasByMonth && citasState.citasByMonth[monthKey]) {
                setHasAppliedNavigationState(true);
            } else {
                setSelectedDate(moment());
                setViewValue('month');
                setTargetCitaId(null);
                setIsRestoringNavigationState(false);
                setHasAppliedNavigationState(true);
            }
        }
    }, [
        history?.location?.state,
        hasAppliedNavigationState,
        empresa,
        profesional?._id,
        socket,
        dispatch,
        citasState.citasByMonth,
    ]);

    useEffect(() => {
        if (targetCitaId) {
            const t = setTimeout(() => setTargetCitaId(null), 1500);
            return () => clearTimeout(t);
        }
    }, [targetCitaId]);

    useEffect(() => {
        if (window.history && window.history.replaceState && !history.location.state) {
            window.history.replaceState({}, document.title, window.location.pathname);
        }

        if (empresa && !isRestoringNavigationState && !history.location.state) {
            // loadEmpresaIfNeeded();
            
            if (usarSockets) {
                socket?.emit('obtener-citas-mes', {
                    empresa,
                    fecha: fechaString,
                    profesionalId: profesional?._id
                });
            } else {
                dispatch(startLoadingPedidosPendientes(empresa));
            }
        }

        return () => {
            dispatch(pedidoLogout());
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        setHasAppliedNavigationState(false);
        setIsRestoringNavigationState(false);
    }, [history.location.pathname]);

    useEffect(() => {
        const handleBeforeUnload = () => {
            setHasAppliedNavigationState(false);
            setTargetCitaId(null);
            if (window.history && window.history.replaceState) {
                window.history.replaceState({}, document.title, window.location.pathname);
            }
        };

        window.addEventListener('beforeunload', handleBeforeUnload);
        
        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, []);

    const isFetchingRef = useRef(false);
    const fechaStringRef = useRef(fechaString);

    useEffect(() => {
        fechaStringRef.current = fechaString;
    }, [fechaString]);

    useEffect(() => {
        if (myTimer.current) {
            clearInterval(myTimer.current);
            myTimer.current = null;
        }

        if (!empresa || activeModalReserva) {
            return;
        }

        myTimer.current = setInterval(async () => {
            if (isFetchingRef.current) {
                return;
            }

            isFetchingRef.current = true;

            try {
                await dispatch(startLoadingPedidosPendientes(empresa));
                await checkModalReserva();
                await dispatch(startLoadingCitasMesForced(empresa, fechaStringRef.current, profesional?._id || undefined));
            } catch (error) {
                console.error('[Reservas] Error en timer:', error);
            } finally {
                isFetchingRef.current = false;
            }

        }, 60000);

        return () => {
            if (myTimer.current) {
                clearInterval(myTimer.current);
                myTimer.current = null;
            }
        };

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [empresa, profesional?._id, activeModalReserva, dispatch]);

    const checkModalReserva = async () => {
        if (justRestoredAt.current && (Date.now() - justRestoredAt.current) < 5000) {
            return;
        }
        if (!activeModalReserva) {
            await cargaDatos();
        }
    }

    useEffect(() => {
        dispatch(setBodyClass('reservar'));
        dispatch(setMenuLateral('reservas'));
        if (empresa) {
            dispatch(startLoadingVacacionesEmpresa(empresa));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch, empresa]);

    useEffect(() => {
        if (modalResponse === 100) {
            // loadCitasIfNeeded();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [modalResponse])

    useEffect(() => {
        console.log('[Reservas] useEffect cambio de fecha ejecutándose', {
            empresa: !!empresa,
            selectedDate: selectedDate?.format('YYYY-MM-DD'),
            isRestoringNavigationState,
            skipNextSelectedDateLoad: skipNextSelectedDateLoad.current
        });
        
        if (empresa && selectedDate && !isRestoringNavigationState) {
            if (skipNextSelectedDateLoad.current) {
                console.log('[Reservas] Saltando carga por skipNextSelectedDateLoad');
                skipNextSelectedDateLoad.current = false;
                return;
            }
            
            const monthKey = fechaString.substring(0, 7);
            const hasCachedData = citasState.citasByMonth && citasState.citasByMonth[monthKey];
            
            if (hasCachedData) {
                console.log('[Reservas] Usando citas del cache para', monthKey);
                dispatch(setCitas({ 
                    citas: citasState.citasByMonth[monthKey], 
                    fecha: fechaString 
                }));
            } else {
                if (usarSockets) {
                    console.log('[Reservas] Emitiendo socket para cambio de fecha...');
                    socket?.emit('obtener-citas-mes', {
                        empresa,
                        fecha: fechaString,
                        profesionalId: profesional?._id
                    });
                } else {
                    console.log('[Reservas] Cargando citas por cambio de fecha...');
                    dispatch(startLoadingCitasMes(empresa, fechaString, profesional?._id));
                }
            }
        } else {
            console.log('[Reservas] Saltando carga por condiciones:', {
                reason: !empresa ? 'Sin empresa' : !selectedDate ? 'Sin fecha' : 'Restaurando navegación'
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedDate, empresa]);

    useEffect(() => {
        if (!firstTime && sucursales.length > 0 && profesionales.length > 0) {
            processSucursales();
            processProfesionales();
            setFirstTime(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [sucursales, profesionales, firstTime]);

    useEffect(() => {
        console.log('[Reservas] Cambio de vista detectado:', viewValue);
        
        setIsRestoringNavigationState(false);
        skipNextSelectedDateLoad.current = false;
        
        if (empresa && selectedDate) {
            const monthKey = fechaString.substring(0, 7);
            const hasCachedData = citasState.citasByMonth && citasState.citasByMonth[monthKey];
            
            if (hasCachedData) {
                console.log('[Reservas] Restaurando citas del cache al cambiar de vista');
                dispatch(setCitas({ 
                    citas: citasState.citasByMonth[monthKey], 
                    fecha: fechaString 
                }));
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [viewValue]);

    useEffect(() => {
        if (firstTime && (arrSucursales.length > 0 || arrProfesionales.length > 0)) {
            const filtersToSave = {
                sucursales: arrSucursales,
                profesionales: arrProfesionales,
                timestamp: Date.now()
            };
            localStorage.setItem('reservas_filters', JSON.stringify(filtersToSave));
        }
    }, [arrSucursales, arrProfesionales, firstTime]);

    const cargaDatos = async () => {
        if (!usarSockets) {
            setIsRecharging(true);
            try {
                await dispatch(startLoadingPedidosPendientes(empresa));
            } finally {
                setIsRecharging(false);
            }
        }
    };

    const processSucursales = () => {
        let newArray = [];
        
        const savedFilters = localStorage.getItem('reservas_filters');
        let savedSucursales = [];
        
        if (savedFilters) {
            try {
                const parsedFilters = JSON.parse(savedFilters);
                savedSucursales = parsedFilters.sucursales || [];
            } catch (error) {
                console.error('Error parsing saved filters:', error);
            }
        }
        
        sucursales.map(sucursal => {
            const savedSucursal = savedSucursales.find(s => s.sucursal._id === sucursal._id);
            const isSelected = savedSucursal ? savedSucursal.selected : true;
            
            const item = {
                sucursal,
                selected: isSelected
            }
            newArray = [...newArray, item];
            return sucursal;
        });
        setArrSucursales(newArray);
    };

    const processProfesionales = () => {
        let newArray = [];
        
        const savedFilters = localStorage.getItem('reservas_filters');
        let savedProfesionales = [];
        
        if (savedFilters) {
            try {
                const parsedFilters = JSON.parse(savedFilters);
                savedProfesionales = parsedFilters.profesionales || [];
            } catch (error) {
                console.error('Error parsing saved filters:', error);
            }
        }
        
        profesionales.map((profesional, idx) => {
            const savedProfesional = savedProfesionales.find(p => p.profesional?._id === profesional._id);
            const isSelected = savedProfesional ? savedProfesional.selected : true;
            
            const item = {
                profesional,
                idx: idx + 1,
                selected: isSelected
            }
            newArray = [...newArray, item];
            return profesional;
        });
        setArrProfesionales(newArray);
    };

    const clearAllFilters = () => {
        localStorage.removeItem('reservas_filters');
        
        const resetSucursales = sucursales.map(sucursal => ({
            sucursal,
            selected: true
        }));
        
        const resetProfesionales = profesionales.map((profesional, idx) => ({
            profesional,
            idx: idx + 1,
            selected: true
        }));
        
        setArrSucursales(resetSucursales);
        setArrProfesionales(resetProfesionales);
        
        console.log('Filtros borrados y reseteados a valores por defecto');
    };

	const handlePayment = () => {
        setActiveModalVentas(true);
        setActiveModalReserva(false);
    };

    const handleVentasClose = () => {
        setActiveModalVentas(false);
        setVentaModoCitaCompleta(false);
        dispatch(unactiveServicio());
    };

    const handleNewSale = () => {
        dispatch(unactiveCita());
        setActiveModalVentas(true);
    };

    return (
        <>
            <Filters
                arrSucursales={arrSucursales}
                setArrSucursales={setArrSucursales}
                arrProfesionales={arrProfesionales}
                setArrProfesionales={setArrProfesionales}
                miniLateral={miniLateral}
                setMiniLateral={setMiniLateral}
                miniFilters={miniFilters}
                setMiniFilters={setMiniFilters}
                agendaActive={agendaActive}
                clearAllFilters={clearAllFilters}
            />
            <div
                className={`calendar ${agendaActive ? '' : 'big'}`}
                style={{
                    '--colorPrincipal': colores.colorPrincipal,
                    '--colorSecundario': colores.colorSecundario,
                    '--color3': colores.color3,
                    '--color4': colores.color4,
                    '--color5': colores.color5,
                    '--color6': colores.color6,
                    '--color7': colores.color7,
                }}
            >
                {
                    isLoading &&
                    <div
                        className='loading-citas'
                    >
                        <div className='bg-loading'></div>
                        <p
                            style={{ color: colores.colorPrincipal }}
                        >Cargando...</p>
                    </div>
                }
                <CustomCalendar
                    citas={citas}
                    citasState={citasState}
                    arrSucursales={arrSucursales}
                    arrProfesionales={arrProfesionales}
                    selectedDate={selectedDate}
                    setSelectedDate={setSelectedDate}
                    viewValue={viewValue}
                    setViewValue={setViewValue}
                    setActiveModalReserva={setActiveModalReserva}
                    editCita={editCita}
                    setEditCita={setEditCita}
                    isLoading={isLoading}
                    setIsLoading={setIsLoading}
                    isRecharging={isRecharging}
                    setIsRecharging={setIsRecharging}
                    agendaActive={agendaActive}
                    setAgendaActive={setAgendaActive}
                    handleNewSale={handleNewSale}
                    targetCitaId={targetCitaId}
                    setTargetCitaId={setTargetCitaId}
                    isRestoringNavigationState={isRestoringNavigationState}
                    setIsRestoringNavigationState={setIsRestoringNavigationState}
                    previousSelectedDate={previousSelectedDate}
                    setPreviousSelectedDate={setPreviousSelectedDate}
                    history={history}
                    isReady={firstTime}
                />
            </div>
            <ModalReserva
                activeModalReserva={activeModalReserva}
                setActiveModalReserva={setActiveModalReserva}
                setActiveModalDeleteCita={setActiveModalDeleteCita}
                setEstadoCita={setEstadoCita}
                editCita={editCita}
                setEditCita={setEditCita}
                setDataModal={setDataModal}
                modalResponse={modalResponse}
                setModalResponse={setModalResponse}
                setModalTwoButtonsOpened={setModalTwoButtonsOpened}
                modalWaiting={modalWaiting}
                setModalWaiting={setModalWaiting}
                selectedDate={selectedDate}
                viewValue={viewValue}
                setActiveModalVentas={setActiveModalVentas}
                setVentaModoCitaCompleta={setVentaModoCitaCompleta}
                previousSelectedDate={previousSelectedDate}
            />
            <ModalDeleteCita
                activeModalDeleteCita={activeModalDeleteCita}
                setActiveModalDeleteCita={setActiveModalDeleteCita}
                estadoCita={estadoCita}
                setEstadoCita={setEstadoCita}
            />
            <ModalVentas
                activeModalVentas={activeModalVentas}
                onClose={handleVentasClose}
                citaActive={citaActive}
                setActiveModalReserva={setActiveModalReserva}
                ventaModoCitaCompleta={ventaModoCitaCompleta}
                setVentaModoCitaCompleta={setVentaModoCitaCompleta}
                setDataModal={setDataModal}
                setModalTwoButtonsOpened={setModalTwoButtonsOpened}
            />
            <YlmModalTwoButtons
                data={dataModal}
                setModalResponse={setModalResponse}
                modalTwoButtonsOpened={modalTwoButtonsOpened}
                setModalTwoButtonsOpened={setModalTwoButtonsOpened}
            />
            <div className={`fondo-no-click ${(activeModalReserva || activeModalVentas) ? 'active' : ''}`}></div>
        </>
    )
}

